import {
  enrichAssignmentRows,
} from "../../../../components/request/requestAssignmentDisplay";
import {
  enrichAllRequestRows,
  pickChipLabel,
  OPS_EMPTY_LABEL,
  OPS_NOT_AVAILABLE_LABEL,
} from "../../solarent-operator/all-requests/allRequestsPageUtils";

export { OPS_EMPTY_LABEL, OPS_NOT_AVAILABLE_LABEL, pickChipLabel };

/** خلاصه عملیاتی برای گرید مدیریت */
export const enrichManagementOperationalRows = (list, currentUserId) => {
  const base = enrichAllRequestRows(enrichAssignmentRows(list), currentUserId);

  return base.map((row) => {
    const ownerRaw =
      row.assignedOperatorDisplay === "بدون مسئول"
        ? null
        : row.assignedOperatorDisplay;

    return {
      ...row,
      opsOwnerLabel: pickChipLabel(ownerRaw, "بدون مسئول"),
      opsOwnerColor: row.assignedOperatorChipColor || "default",
      opsLeadPriorityLabel: pickChipLabel(
        row.leadPriorityTitle ?? row.LeadPriorityTitle,
        OPS_EMPTY_LABEL
      ),
      opsLeadPriorityColor:
        row.leadPriorityColor ?? row.LeadPriorityColor ?? "default",
      opsFollowUpLabel: pickChipLabel(
        row.followUpReminderTitle ?? row.FollowUpReminderTitle,
        OPS_EMPTY_LABEL
      ),
      opsFollowUpColor:
        row.followUpReminderColor ?? row.FollowUpReminderColor ?? "default",
      // mehrsan/lending chips already set in enrichAllRequestRows via mapOperationsSummaryChips
    };
  });
};
